import { ContestStatus } from '@betterpool/api-types/contests-service';

import { useContestContext } from '../../../../common/context/ContestContext/ContestContext';
import GamecenterModalsContextProvider from '../../../../common/context/GamecenterModalsContext/GamecenterModalsContextProvider';

import PlayerTierEntriesPageScheduled from './_entriesScheduled';
import GamecenterStandingsOverallPlayerTierEntriesNonScheduledPage from './_entriesNonScheduled';

function PlayerTierEntriesOverallPage() {
  const { contest } = useContestContext();

  return (
    <GamecenterModalsContextProvider>
      {contest.status === ContestStatus.SCHEDULED ? (
        <PlayerTierEntriesPageScheduled />
      ) : (
        <GamecenterStandingsOverallPlayerTierEntriesNonScheduledPage />
      )}
    </GamecenterModalsContextProvider>
  );
}

export default PlayerTierEntriesOverallPage;
